import { ListManager, PageHeader, Styles } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterAdoptions from '../../components/FilterAdoptions'

function AdoptionsByAgeGroup({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.adoptionsByAgeGroup,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Relatório de adoções por faixa etária"
        subtitle="Lista de adoções confirmadas por faixa etária dos adotantes"
        icon="fas fa-blind"
        rightAction={() => <FilterAdoptions donors={data?.donors} />}
      />
      <ListManager
        count={data?.rows?.length || 0}
        loading={loading}
        error={error}
      >
        {Boolean(data) && (
          <table className="table table-hover text-small">
            <thead>
              <tr>
                <th>Faixa Etária</th>
                <th className="text-right" width="300px">
                  Quantidade de adoções
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.rows.map((row) => (
                <tr key={row?.faixa_etaria}>
                  <td>{row?.faixa_etaria}</td>
                  <td className="text-right">{row?.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default AdoptionsByAgeGroup
